import React, { useEffect, useState, useCallback } from 'react';
import uuid from 'uuid';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import UpFlowTouchpoint from '@atlassian/jira-up-flow-touchpoint/src/main.tsx';
import RolesPicker from '../../../../common/ui/roles-picker';
import { useInlineDialog } from '../../../../controllers/table-touchpoint-controller';
import messages from './messages';
import type { Props } from './types';

const PermissionGatedRole = (props: Props) => {
	const { actor, roles, intl, applicationName } = props;
	const [id] = useState<string>(uuid());
	const [{ isOpen }, actions] = useInlineDialog();
	useEffect(() => {
		actions.register(id);

		return () => {
			actions.unregister(id);
		};
	}, [actions, id]);
	const onOpen = useCallback((): void => {
		actions.openModal(id);
	}, [actions, id]);
	const onClose = useCallback((): void => {
		actions.closeModal();
	}, [actions]);

	return (
		<UpFlowTouchpoint
			feature="permission"
			touchpointId="projectSettingsAccessPermissionGatedRole"
			internationalizedMessage={intl.formatMessage(messages.permissionGateTooltip, {
				applicationName,
			})}
			placement="bottom-end"
			isOpen={isOpen[id]}
			onClose={onClose}
			onOpen={onOpen}
			actionSubjectId="permissionGatedRole"
		>
			<RolesPicker isDisabled shouldFitContainer actor={actor} roles={roles} />
		</UpFlowTouchpoint>
	);
};

export default injectIntl(PermissionGatedRole);
